import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gtd-ui-field-special-author',
  templateUrl: './author.component.html',
})
export class AuthorComponent {
  @Input() data: any;

  getName(data): string {
    const name = data.name ? data.name : `${data.first_name} ${data.last_name}`.trim();

    return `${name}${data.id ? ' / ' + data.id : ''}`;
  }
}
